import headerStyles from "../../theme/header.module.css";
import { FormattedMessage } from "react-intl";
import { IonTitle, isPlatform } from "@ionic/react";
import {
  IconFileText,
  IconFiles,
  IconWorld,
  IconPlug,
  IconSparkles,
  IconFilter,
  IconScript
} from "@tabler/icons-react";
const isMobile = isPlatform("android") || isPlatform("ios");

const MobileHeader = ({ id }: { id: string }) => (
  <div className="view-pane">
    <div>
      <div className={headerStyles.header}>
        <h1 className={headerStyles.mobileTitle}>
          <FormattedMessage id={id} />
        </h1>
        <h3 className={headerStyles.mobileDescription}>
          <FormattedMessage id={`${id}.desc`} />
        </h3>
      </div>
    </div>
  </div>
);

const DesktopHeader = ({ id }: { id: string }) => (
  <div className="pt-3 px-4 flex-shrink-0">
    <h1 className={headerStyles.pageTitle}>
      <FormattedMessage id={id} />
    </h1>
    <h3 className={headerStyles.pageDescription}>
      <FormattedMessage id={`${id}.desc`} />
    </h3>
  </div>
);

export const NAV_ITEMS = [
  {
    path: "/ai/website",
    key: "website",
    label: "ai.sources.website",
    recommended: true,
    icon: <IconWorld size={isMobile ? undefined : 17} />,
  },
  {
    path: "/ai/text",
    key: "text",
    label: "ai.sources.text",
    icon: <IconFileText size={isMobile ? undefined : 17} />,
  },
  {
    path: "/ai/files",
    key: "files",
    label: "ai.sources.files",
    icon: <IconFiles size={isMobile ? undefined : 17} />,
  },
  {
    path: "/ai/providers",
    key: "provider",
    label: "ai.sources.providers",
    icon: <IconPlug size={isMobile ? undefined : 17} />,
  },
];

export const EXPERIENCE_ITEMS = [
  /*
  {
    path: "/ai/behavior",
    key: "behavior",
    label: "ai.settings.instructions",
    icon: <IconBellPlus size={isMobile ? undefined : 17} />,
  },
  */
 {
    path: "/ai/system-prompt",
    key: "prompt",
    label: "ai.settings.instructions",
    icon: <IconScript size={isMobile ? undefined : 17} />,
  },
  {
    path: "/ai/escalations",
    key: "escalations",
    label: "ai.settings.escalations",
    icon: <IconSparkles size={isMobile ? undefined : 17} />,
  },
  {
    path: "/ai/follow-ups",
    key: "followups",
    label: "ai.settings.followUps",
    icon: <IconFilter size={isMobile ? undefined : 17} />,
  },
  /*
  {
    path: "/ai/bookings",
    key: "bookings",
    label: "ai.settings.aiBookings",
    icon: <IconCalendarDollar size={isMobile ? undefined : 17} />,
  },
  */
];

const HEADER_DESCRIPTIONS: Record<string, React.ReactNode> = {
  "/ai": isMobile ? (
    <MobileHeader id="ai.sources.flow" />
  ) : (
    <DesktopHeader id="ai.sources.flow" />
  ),
  "/ai/website": isMobile ? (
    <MobileHeader id="ai.sources.website" />
  ) : (
    <DesktopHeader id="ai.sources.website" />
  ),
  "/ai/text": isMobile ? (
    <MobileHeader id="ai.sources.text" />
  ) : (
    <DesktopHeader id="ai.sources.text" />
  ),
  "/ai/files": isMobile ? (
    <MobileHeader id="ai.sources.files" />
  ) : (
    <DesktopHeader id="ai.sources.files" />
  ),
  "/ai/providers": isMobile ? (
    <MobileHeader id="ai.sources.providers" />
  ) : (
    <DesktopHeader id="ai.sources.providers" />
  ),
  "/ai/customer": isMobile ? (
    <MobileHeader id="ai.sources.customer" />
  ) : (
    <DesktopHeader id="ai.sources.customer" />
  ),
  "/ai/escalations": isMobile ? (
    <MobileHeader id="ai.settings.escalations" />
  ) : (
    <DesktopHeader id="ai.settings.escalations" />
  ),
  "/ai/follow-ups": isMobile ? (
    <MobileHeader id="ai.settings.followUps" />
  ) : (
    <DesktopHeader id="ai.settings.followUps" />
  ),
  "/ai/system-prompt": isMobile ? (
    <MobileHeader id="ai.settings.instructions" />
  ) : (
    <DesktopHeader id="ai.settings.instructions" />
  ),
  "/ai/integrations": isMobile ? (
    <MobileHeader id="ai.sources.providers" />
  ) : (
    <DesktopHeader id="ai.sources.providers" />
  ),
  "/integrations": isMobile ? (
    <MobileHeader id="ai.sources.providers" />
  ) : (
    <DesktopHeader id="ai.sources.providers" />
  ),
  "/ai/channels": isMobile ? (
    <MobileHeader id="ai.sources.channels" />
  ) : (
    <DesktopHeader id="ai.sources.channels" />
  ),
  "/connect": isMobile ? (
    <MobileHeader id="ai.sources.channels" />
  ) : (
    <DesktopHeader id="ai.sources.channels" />
  ),
};

export const MOBILE_HEADER_TITLES: Record<string, React.ReactNode> = {
  "/ai/playground": (
    <IonTitle>
      <FormattedMessage id="ai.playground" />
    </IonTitle>
  ),
  "/ai/website": (
    <IonTitle>
      <FormattedMessage id="ai.sources.website" />
    </IonTitle>
  ),
  "/ai/text": (
    <IonTitle>
      <FormattedMessage id="ai.sources.text" />
    </IonTitle>
  ),
  "/ai/files": (
    <IonTitle>
      <FormattedMessage id="ai.sources.files" />
    </IonTitle>
  ),
  "/ai/system-prompt": (
    <IonTitle>
      <FormattedMessage id="ai.settings.instructions" />
    </IonTitle>
  ),
  "/ai/escalations": (
    <IonTitle>
      <FormattedMessage id="ai.settings.escalations" />
    </IonTitle>
  ),
  "/ai/follow-ups": (
    <IonTitle>
      <FormattedMessage id="ai.settings.followUps" />
    </IonTitle>
  ),
  "/ai/channels": (
    <IonTitle>
      <FormattedMessage id="nav.channels" />
    </IonTitle>
  ),
  "/ai/integrations": (
    <IonTitle>
      <FormattedMessage id="nav.integrations" />
    </IonTitle>
  ),
};

export default HEADER_DESCRIPTIONS;
